import React, { useEffect } from "react";
import LayoutNav from "containers/LayoutNav";
import { useDispatch, useSelector } from "react-redux";

import { updateSidePanelAction } from "store/actions/sidepanel";
import { setPageLayouts } from "store/thunk/layout";

import { extractSystemId } from "utils/utils";
import { AnalyticsStrings } from "constants/constantStrings";
import { SYSTEMS_PAGES } from "constants/pages.constant";

const AnalyticsSideNav = () => {
  const dispatch = useDispatch();
  const { user, sidePanelData } = useSelector(state => state);

  const systemID = extractSystemId();
  const { isAnalyticsPanelOpened } = sidePanelData;

  const onToggleCollapsedNav = () => dispatch(updateSidePanelAction({ isAnalyticsPanelOpened: !isAnalyticsPanelOpened }));

  useEffect(() => {
    const SystemID = extractSystemId();
    const layouts = [
      {
        Home: true,
        ID: "1",
        SystemID,
        Name: AnalyticsStrings.layoutName,
        Type: AnalyticsStrings.analytics,
        PrimaryMail: user.UserEmail,
        UserID: user.UserID,
        Username: user.UserName
      }
    ];
    dispatch(setPageLayouts(layouts, null, SYSTEMS_PAGES.ANALYTICS));
  }, []);

  return (
    <div className="sideNavMainContainer">
      <div
        className={`sideNavMenubutton ${
          isAnalyticsPanelOpened ? "sideNavOpenMenuwidth sideNavCloseMenuButton" : "sideNavCloseMenuwidth sideNavOpenMenuButton"
        }`}
        onClick={onToggleCollapsedNav}
      />
      {isAnalyticsPanelOpened && (
        <div className="sideNavMenuOpen">
          <LayoutNav page={SYSTEMS_PAGES.ANALYTICS} systemID={systemID} />
        </div>
      )}
    </div>
  );
};

export default AnalyticsSideNav;
